import { render, staticRenderFns } from "./HonorPage.vue?vue&type=template&id=ab8c0edc&scoped=true"
import script from "./HonorPage.vue?vue&type=script&lang=js"
export * from "./HonorPage.vue?vue&type=script&lang=js"
import style0 from "./HonorPage.vue?vue&type=style&index=0&id=ab8c0edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8c0edc",
  null
  
)

export default component.exports